const data = {
  Hawaii: [
    "96704",
    "96710",
    "96719",
    "96720",
    "96725",
    "96726",
    "96727",
    "96728",
    "96737",
    "96738",
    "96740",
    "96743",
    "96749",
    "96750",
    "96755",
    "96760",
    "96764",
    "96771",
    "96772",
    "96773",
    "96774",
    "96776",
    "96777",
    "96778",
    "96780",
    "96781",
    "96783",
    "96785",
  ],
  Maui: [
    "96708",
    "96713",
    "96732",
    "96753",
    "96761",
    "96768",
    "96779",
    "96790",
    "96793",
  ],
  Oahu: [
    "96701",
    "96706",
    "96707",
    "96712",
    "96717",
    "96730",
    "96731",
    "96734",
    "96744",
    "96759",
    "96762",
    "96782",
    "96786",
    "96789",
    "96791",
    "96792",
    "96815",
    "96816",
    "96817",
    "96818",
    "96819",
    "96821",
    "96822",
    "96825",
    "96826",
    "96850",
    "96853",
    "96857",
    "96859",
    "96860",
    "96863",
  ],
  Kauai: [
    "96703",
    "96705",
    "96714",
    "96716",
    "96722",
    "96741",
    "96746",
    "96747",
    "96751",
    "96752",
    "96754",
    "96756",
    "96765",
    "96766",
    "96769",
    "96796",
  ],
};

type Island = "Hawaii" | "Maui" | "Oahu" | "Kauai";

const getZipCode = (island: Island) => {
  return data[island];
};

export type { Island };
export default getZipCode;
